<template>
    <div class="wrapper">
        <v-head></v-head>
        <v-sidebar></v-sidebar>
		<audio id="notify" src="../../assets/mp3/notify.mp3" style="width:1px;height:1px"></audio>
		<audio id="warning" src="../../assets/mp3/warning.mp3" style="width:1px;height:1px"></audio>
        <div class="content-box" :class="{'content-collapse':collapse}">
            <v-tags></v-tags>
            <div class="content" @scroll="onScroll">
                <transition name="move" mode="out-in">
                    <keep-alive :include="tagsList">
                        <router-view></router-view>
                    </keep-alive>
                </transition>
                <el-backtop target=".content"></el-backtop>
            </div>
			<v-MessageDrawer></v-MessageDrawer>
        </div>
    </div>
</template>

<style>
	.custom-notification div{
		width: 100%;
	}
	.custom-notification {
		&.el-notification {
			width: 400px;
		}
	}
</style>
<script>
import vHead from './Header.vue';
import vSidebar from './Sidebar.vue';
import vTags from './Tags.vue';
import bus from './bus';
import { initSocket, startSocket } from '../../utils/websocket'
import { generateRandomString } from '../../utils/common'
import { getUnreadQzone, readMessage, getUnReadMessage} from '../../api/index'
import { getControll } from '../../utils/controlls';
import vMessageDrawer from '../common/MessageDrawer.vue';
export default {
    data() {
        return {
            tagsList: [],
            collapse: false,
			notifys:{},
			unReadQzoneSize:0,
			controll:{}
        };
    },
    components: {
        vHead,
        vSidebar,
        vTags,
		vMessageDrawer
    },
    created() {
        bus.$on('collapse-content', msg => {
            this.collapse = msg;
        });
		bus.$on('message-notify-close', msg => {
            this.closeAll();
        });
		bus.$on('message-drawer-open', msg => {
            this.closeAll();
        });
        // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
        bus.$on('tags', msg => {
            let arr = [];
            for (let i = 0, len = msg.length; i < len; i++) {
                msg[i].name && arr.push(msg[i].name);
            }
            this.tagsList = arr;
        });
		this.websocketLogin();
		window.addEventListener('chessQzoneChangeNotify', this.notifyDeal);
		window.addEventListener('todoNotify', this.notifyDeal);
		window.addEventListener('checkNotify', this.notifyDeal);
		window.addEventListener('unCheckNotify', this.notifyDeal);
		window.addEventListener('confirmNotify', this.notifyDeal);
		window.addEventListener('refuseNotify', this.notifyDeal);
		window.addEventListener('amountChangeNotify', this.notifyDeal);
		window.addEventListener('systemNotify', this.notifyDeal);
		window.addEventListener('businessNotify', this.notifyDeal);
		window.addEventListener('noticeNotify', this.notifyDeal);
		window.addEventListener('elseNotify', this.notifyDeal);
		window.addEventListener('renewalNotify', this.notifyDeal);
		window.addEventListener('dataChangeNotify', this.dataChangeDeal);
		
		window.addEventListener('taxNotify', this.notifyDeal);
		window.addEventListener('orderNotify', this.notifyDeal);
		window.addEventListener('paymentNotify', this.notifyDeal);
		window.addEventListener('reconciliationNotify', this.notifyDeal);
		
		this.controll = getControll("header");
		if (this.controll["chess-qzone"]) {
			this.getUnReadQzoneSize();
		}
		if (!window.location.host.startsWith("system")) {
			this.getUnReadMessageMap();
		}
    },
	destroyed() {
		window.removeEventListener('chessQzoneChangeNotify', this.notifyDeal);
		window.removeEventListener('todoNotify', this.notifyDeal);
		window.removeEventListener('checkNotify', this.notifyDeal);
		window.removeEventListener('unCheckNotify', this.notifyDeal);
		window.removeEventListener('confirmNotify', this.notifyDeal);
		window.removeEventListener('refuseNotify', this.notifyDeal);
		window.removeEventListener('amountChangeNotify', this.notifyDeal);
		window.removeEventListener('systemNotify', this.notifyDeal);
		window.removeEventListener('businessNotify', this.notifyDeal);
		window.removeEventListener('noticeNotify', this.notifyDeal);
		window.removeEventListener('elseNotify', this.notifyDeal);
		window.removeEventListener('renewalNotify', this.notifyDeal);
		window.removeEventListener('dataChangeNotify', this.dataChangeDeal);
		window.removeEventListener('taxNotify', this.notifyDeal);
		window.removeEventListener('orderNotify', this.notifyDeal);
		window.removeEventListener('paymentNotify', this.notifyDeal);
		window.removeEventListener('reconciliationNotify', this.notifyDeal);
	},
	mounted() {
		//将Vue方法传到全局对象window中
		window.choose_router_and_close = this.chooseRouterAndClose;
		window.message_close = this.messageClose;
	},
	methods: {
		closeAll() {
			for (let key in this.notifys) {
				this.notifys[key].close();
				delete this.notifys[key];
			}
		},
		//websocket 登录
		websocketLogin() {
			let ckey = localStorage.getItem('ms_ckey');
            if (!ckey){
			   return;
			}
			let dkey = localStorage.getItem('ms_dkey');
            if (!dkey){
			   return;
			}
			let ukey = localStorage.getItem('ms_ukey');
            if (!ukey){
			   return;
			}
			let wsUrl = "/websocket/point/" + ckey + "/" + dkey + "/" + ukey;
			initSocket(wsUrl);
			startSocket();
		},
		// websocket消息提示
		notifyDeal(message) {
			let messageData = JSON.parse(message.detail);
			var notifyAudio = document.getElementById('notify');
			var warningAudio = document.getElementById('warning');
			if (messageData.notifyType==0||messageData.notifyType==2) {
				notifyAudio.play();
			} else {
				warningAudio.play();
			}
			let notifyForm = messageData.notifyType==2?this.$notify.success:
			(messageData.notifyType==1?this.$notify.warning:
			(messageData.notifyType==3?this.$notify.error:this.$notify.info)); 
			let key = messageData.event + "_" + messageData.data.id + generateRandomString(16);
			let filter = btoa(JSON.stringify(messageData.data.filterParams));
			let notify = notifyForm({
				dangerouslyUseHTMLString: true,
				title: messageData.data.title,
				message: '<div id = "message" style="width:100%">' + messageData.data.content 
				+ '</div><br>' 
				+ (messageData.data.path?'<div style="width:100%; text-align:right;">'
				+ '<a href="javascript:void(0)" onclick="choose_router_and_close(\'' 
				+ messageData.data.path + '\', \'' + key + '\', \'' 
				+ messageData.data.messageId + '\', \'' 
				+ filter + '\');">详情</a></div>':
				'<div style="width:100%; text-align:right;">'
				+ '<a href="javascript:void(0)" onclick="message_close(\'' + key + '\', \'' 
				+ messageData.data.messageId + '\');">知道了</a></div>'),
				position: 'bottom-right',
				duration:0,
				customClass: 'custom-notification'
			});
			this.notifys[key] = notify;
			if (messageData.event.startsWith("qzone")) {
				this.unReadQzoneSize = this.unReadQzoneSize + 1;
				bus.$emit('unReadQzoneSize', this.unReadQzoneSize);
			} else if (messageData.event.startsWith("todo")) {
				bus.$emit('todoListRefresh', "");
			}
			if (messageData.event.startsWith("taxNotify") || messageData.event.startsWith("orderNotify")
				|| messageData.event.startsWith("paymentNotify") 
				|| messageData.event.startsWith("reconciliationNotify")) {
				return;
			}
			if (!messageData.data.loginMessage) {
				bus.$emit("unReadMessageSizeUpdate", 1);
			}
		},
		//消息详情跳转
		chooseRouterAndClose(route, key, messageId, filter) {
			let filterParams = JSON.parse(atob(filter));
			if (route == "message-drawer-open") {
				bus.$emit("message-drawer-open", undefined);
				this.notifys[key].close();
				delete this.notifys[key];
				return;
			} else {
				if (route.startsWith("http://") || route.startsWith("https://")) {
					var a = document.createElement('a');
					a.href = route;
					a.target = "_blank";
					a.click();
				} else {
					this.$router.push({path: route});
					setTimeout(()=>{
						if (filterParams != undefined && filterParams != "null") {
							bus.$emit(route, filterParams);
						}
					}, 1000);
				}
			}
			this.messageClose(key, messageId);
		},
		messageClose(key, messageId) {
			if (key && key.startsWith("qzone")) {
				this.unReadQzoneSize = 0
				bus.$emit('unReadQzoneSize', 0);
			}
			if (messageId && messageId != "null") {
				readMessage([messageId]).then(res => {
					if (res.code == 0) {
						bus.$emit('message-read', messageId);
						bus.$emit("unReadMessageSizeUpdate", -1);
					}
				})
			}
			this.notifys[key].close();
			delete this.notifys[key];
		},
		onScroll() {
			window.dispatchEvent(new CustomEvent('onScrollEvent', {}))
		},
		getUnReadQzoneSize(){
			getUnreadQzone().then(res => {
				if (res.code == 0) {
					this.unReadQzoneSize = res.data.length;
					bus.$emit('unReadQzoneSize', this.unReadQzoneSize);
				}
			});
		},
		getUnReadMessageMap() {
			getUnReadMessage().then(res => {
				if (res.code == 0) {
					bus.$emit('unReadMessageSize', res.data);
				}
			})
		},
		dataChangeDeal(message) {
			let messageData = JSON.parse(message.detail);
			let data = JSON.parse(messageData.data.content);
			if (data.dataType == "localStorage") {
				if (data.key == "ms_companyName") {
					bus.$emit('companyNameChange', data.value);
				}
			}
		}
	}
};
</script>
